var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyInbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.99 41.96c0-.12-.02-.23-.07-.34l-11-26v-.01a.999.999 0 0 0-.2-.29c-.02-.02-.05-.04-.07-.06a1.07 1.07 0 0 0-.22-.15c-.04-.02-.08-.03-.12-.04-.08-.03-.16-.04-.24-.05-.02 0-.04-.01-.06-.01h-1.27c-.55 0-1 .45-1 1s.45 1 1 1h.27v8h-1.52c-.55 0-1 .45-1 1s.45 1 1 1h1.78l4.38 14H38.01c-.38 0-.72.21-.89.55l-1.72 3.45h-6.76l-1.72-3.45a1 1 0 0 0-.89-.55h-7c-.55 0-1 .45-1 1s.45 1 1 1h6.38l1.72 3.45a1 1 0 0 0 .89.55h8c.38 0 .72-.21.89-.55l1.72-3.45h21.38v14h-16c-.55 0-1 .45-1 1s.45 1 1 1h17c.55 0 1-.45 1-1V41.97zM55.73 41l-4.74-15.15v-4.92L59.48 41h-3.76z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 57H4V43h11c.55 0 1-.45 1-1s-.45-1-1-1h-4.64l4.38-14h1.78c.55 0 1-.45 1-1s-.45-1-1-1H15v-8h.28c.55 0 1-.45 1-1s-.45-1-1-1H14s-.04.01-.06.01c-.08 0-.16.02-.24.05-.04.01-.08.02-.12.04-.08.04-.15.09-.21.14-.03.02-.06.04-.08.06-.08.08-.15.18-.2.3L2.08 41.61c-.05.11-.06.23-.07.34v16.04c0 .55.45 1 1 1h37c.55 0 1-.45 1-1s-.45-1-1-1zM13 20.93v4.92L8.26 41H4.5l8.49-20.07zM49 51h7c.55 0 1-.45 1-1s-.45-1-1-1h-7c-.55 0-1 .45-1 1s.45 1 1 1zM49 55h7c.55 0 1-.45 1-1s-.45-1-1-1h-7c-.55 0-1 .45-1 1s.45 1 1 1zM37.71 13.29a.996.996 0 0 0-1.41 0l-4.29 4.29-4.29-4.29a.996.996 0 1 0-1.41 1.41l4.29 4.29-4.29 4.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l4.29-4.29 4.29 4.29c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-4.29-4.29 4.29-4.29a.996.996 0 0 0 0-1.41z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.82 32.64 2.33 3.88c.18.3.51.49.86.49s.68-.18.86-.49l2.33-3.88c6.29-1.47 10.82-7.13 10.82-13.64 0-2.72-.78-5.36-2.26-7.62-.3-.46-.92-.59-1.38-.29s-.59.92-.29 1.38c1.27 1.93 1.94 4.19 1.94 6.52 0 5.7-4.06 10.65-9.65 11.77-.28.06-.52.22-.66.47l-1.69 2.82-1.69-2.82c-.15-.24-.39-.41-.66-.47-5.59-1.12-9.65-6.07-9.65-11.77 0-6.62 5.38-12 12-12 2.77 0 5.47.96 7.6 2.71.43.35 1.06.29 1.41-.14s.29-1.06-.14-1.41a14.036 14.036 0 0 0-8.87-3.17c-7.72 0-14 6.28-14 14 0 6.5 4.52 12.17 10.82 13.64z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyInbox);
export default __webpack_public_path__ + "static/media/empty-inbox.6b97947cfa06925b72d2c99658f27899.svg";
export { ForwardRef as ReactComponent };